import { FileDescriptorRead, UnitOfMeasure } from "@nens/rana/api-v1";

import { isTypedDescriptor } from "./is-descriptor-type";

/**
 * Get OGC SWE Common Data Model Unit from file descriptor (user supplied) metadata
 */
export const getLegendUnit = (descriptor: FileDescriptorRead): string => {
  if (!isTypedDescriptor(descriptor, "raster")) {
    return "";
  }
  const { userSuppliedMeta, meta } = descriptor;

  const unit: UnitOfMeasure | undefined =
    userSuppliedMeta?.unit ?? meta.rangeType.unit ?? undefined;

  if (!unit) return "";

  const { label, symbol, code } = unit;

  return symbol ?? label ?? String(code);
};
